import { InjectionToken } from '@angular/core';

/** Route used for the Not Found page. */
export const NOT_FOUND_ROUTE = new InjectionToken<string>('NOT_FOUND_ROUTE');

/** Route used to navigate back from the Not Found page. */
export const NOT_FOUND_BACK_ROUTE = new InjectionToken<string>(
    'NOT_FOUND_BACK_ROUTE'
);

/** Translation key for the back button label. */
export const NOT_FOUND_BACK_LABEL_KEY = new InjectionToken<string>(
    'NOT_FOUND_BACK_LABEL_KEY'
);
